import { useState } from 'react';
import { SearchForm } from '../types';
import { validateUserId, validateDate, validateDateRange, formatDateToString } from '../utils';

export const usePeriodForm = (initialForm?: SearchForm) => {
  const [form, setForm] = useState<SearchForm>(
    initialForm || {
      userId: '',
      startDate: '',
      endDate: '',
    }
  );
  
  const [errors, setErrors] = useState<Partial<SearchForm>>({});

  const handleUserIdChange = (value: string) => {
    const sanitizedValue = value.replace(/\D/g, '');
    setForm(prev => ({ ...prev, userId: sanitizedValue }));
    if (errors.userId) {
      setErrors(prev => ({ ...prev, userId: undefined }));
    }
  };

  const handleStartDateChange = (date: Date | null) => {
    const dateString = date ? formatDateToString(date) : '';
    setForm(prev => ({ ...prev, startDate: dateString }));
    if (errors.startDate) {
      setErrors(prev => ({ ...prev, startDate: undefined }));
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    const dateString = date ? formatDateToString(date) : '';
    setForm(prev => ({ ...prev, endDate: dateString }));
    if (errors.endDate) {
      setErrors(prev => ({ ...prev, endDate: undefined }));
    }
  };

  const validate = (): boolean => {
    const newErrors: Partial<SearchForm> = {};

    if (!form.userId) {
      newErrors.userId = 'ユーザIDを入力してください';
    } else if (!validateUserId(form.userId)) {
      newErrors.userId = '有効なユーザIDを入力してください';
    }

    if (!form.startDate) {
      newErrors.startDate = '開始日を選択してください';
    } else if (!validateDate(form.startDate)) {
      newErrors.startDate = '有効な日付を入力してください';
    }

    if (!form.endDate) {
      newErrors.endDate = '終了日を選択してください';
    } else if (!validateDate(form.endDate)) {
      newErrors.endDate = '有効な日付を入力してください';
    }

    if (form.startDate && form.endDate && !validateDateRange(form.startDate, form.endDate)) {
      newErrors.endDate = '終了日は開始日以降を選択してください';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return {
    form,
    errors,
    handleUserIdChange,
    handleStartDateChange,
    handleEndDateChange,
    validate,
  };
};
